<template>
    <div class="card">
        <div class="card-header">
            <i class="far fa-envelope me-2"></i>{{ TR.mails }}
        </div>

        <div class="card-body">
            <DADataTableLazy
                v-if="tableOptions"
                ref="contact_table_ref"
                :tableOptions="tableOptions"
                :lazyUrl="lazyUrl"
                :lazyParam="lazyParam"
            />
        </div>
    </div>
</template>


<script scoped>
    import { ref, watchEffect } from "vue";
    import { useStore } from "@/system_modules/store";
    // import moment from "moment-timezone";

    import { G, ajax } from "@/_common";
    import DADataTableLazy from "@/components/table/DADataTableLazy";

    export default {
        title: "mails",
        name: 'ContactP',

        components: {
            DADataTableLazy,
        },
        setup() {
            const store = useStore();

            const tableOptions = ref();
            const contact_table_ref = ref();
            const TR = ref({});

            const lazyUrl = ref(store.getContactLazy());
            const lazyParam = ref(store.getDataTableParams());

            watchEffect(() => {
                TR.value = store.getTranslation();

                tableOptions.value = {
                    date_columns: {'video_date': 'date'},

                    row_buttons: [
                        {
                            private: G.privateIfNotPermission("remove"),
                            label: "",
                            title: TR.value.remove,
                            icon: "fas fa-trash",
                            class: "text-danger",
                            eventCallback: (data) => {
                                G.alert.confirm({ title: TR.value.warning, msg: TR.value.msg_are_you_sure, yesTitle: TR.value.yes, yes: async () => {
                                    await ajax({
                                        url: store.getContactUpdate(data.id),
                                        method: 'delete',
                                        success: (e) => {
                                            let res = e.data || null;
                                            if ( e.status == 200 && res){
                                                contact_table_ref.value.loadLazyData();
                                                G.alert.success(res.detail);
                                            }
                                            else
                                                G.alert.error(res.detail);
                                        },
                                    });
                                }, yesIcon: 'fas fa-check', noIcon: 'fas fa-ban', noTitle: TR.value.no, no: () => {} })
                            },
                        },
                        {
                            // private: G.privateIfNotPermission("update"),
                            label: "",
                            title: TR.value.edit,
                            // icon: "fas fa-pencil-alt",
                            // class: "btn-primary",
                            icon: "fas fa-search",
                            class: "text-info",
                            eventCallback: (data) => {
                                data.permission_method = 'view';

                                G.showModal({
                                    title: TR.value.edit_title,
                                    subTitle: `${data.name} ${data.lastname}`,
                                    dismiss: false,
                                    page: "components/table/DynamicTable2",
                                    data: data,
                                    table_columns: [
                                        {
                                            name: "id",
                                            title: TR.value.id,
                                            value: "id",
                                        },
                                        {
                                            name: "name",
                                            value: "name",
                                            title: TR.value.name,
                                        },
                                        {
                                            name: "lastname",
                                            value: "lastname",
                                            title: TR.value.lastname,
                                        },
                                        {
                                            name: "email",
                                            value: "email",
                                            title: TR.value.email,
                                        },
                                        {
                                            name: "phone",
                                            value: "phone",
                                            title: TR.value.phone,
                                        },
                                        {
                                            name: "content",
                                            value: "content",
                                            title: TR.value.content,
                                        },
                                        {
                                            name: "create_date",
                                            value: (e) => G.formatLocale(e.create_date),
                                            title: TR.value.create_date,
                                            field_type: "label",
                                        },
                                    ],
                                    toolbar: {
                                        leftSide: {
                                            buttons: [
                                                {
                                                    label: TR.value.close,
                                                    icon: "fas fa-times",
                                                    class: "btn-secondary",
                                                    eventCallback: (el) => {
                                                        G.closeModal(el);
                                                    },
                                                },
                                            ],
                                        },
                                    },
                                });
                            },
                        },
                    ],
                    data_table_columns: [
                        {
                            name: "id",
                            title: TR.value.id,
                            value: "id",
                            class: 'text-center',
                            filter: false,
                        },
                        {
                            name: "name",
                            value: (e) => e.name,
                            title: TR.value.name,
                        },
                        {
                            name: "lastname",
                            value: (e) => e.lastname,
                            title: TR.value.lastname,
                        },
                        {
                            name: "email",
                            value: (e) => e.email,
                            title: TR.value.email,
                        },
                        {
                            name: "phone",
                            value: (e) => e.phone,
                            title: TR.value.phone,
                        },
                        {
                            name: "create_date",
                            value: "create_date",
                            title: TR.value.create_date,
                            class: 'text-center',
                            filters: {
                                operator: "or",
                                constraints: [{ value: null, matchMode: "dateBefore" }],
                            },
                            date_format: 'dd.mm.yy',
                            field_type: "date",
                            filter_mode: "datetime",
                        },
                    ],
                };

            });

            return {
                TR,
                contact_table_ref,
                tableOptions,
                lazyUrl,
                lazyParam,
            };
        },
    };
</script>

